import React from 'react';
import PropTypes from 'prop-types';
import '../Common.css';
import './Tooltip.css';

/**
 * Universelle Button-Komponente zur Vereinheitlichung von ActionButtons.
 * Verwendet die bestehenden Utility-Klassen aus Common.css.
 */
const Button = ({
  children,
  variant = 'default', // primary | success | danger | outline-primary | default
  size = 'md', // xs | sm | md
  icon = false,
  disabled = false,
  type = 'button',
  ariaLabel,
  title,
  onClick,
  className = '',
  tooltip,
  tooltipAlign = 'center', // center | left | right
}) => {
  const variantClass = variant === 'default' ? '' : `btn-${variant}`;
  const sizeClass = size === 'md' ? '' : `btn-${size}`;
  const iconClass = icon ? 'btn-icon' : '';
  const classes = ['btn', variantClass, sizeClass, iconClass, className]
    .filter(Boolean)
    .join(' ');

  const reactId = React.useId();
  const tooltipId = tooltip ? `${(ariaLabel || title || 'btn').replace(/\s+/g,'-')}-tooltip-${reactId}` : undefined;

  const btnEl = (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
      title={title}
      aria-describedby={tooltipId}
    >
      {children}
    </button>
  );

  if (!tooltip) return btnEl;
  const alignmentClass = tooltipAlign !== 'center' ? `tooltip-${tooltipAlign}` : '';
  return (
    <span className={`btn-tooltip-wrapper ${alignmentClass}`.trim()}>
      {btnEl}
      <span id={tooltipId} role="tooltip" className="btn-tooltip">{tooltip}</span>
    </span>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['default', 'primary', 'success', 'danger', 'outline-primary']),
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  icon: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipAlign: PropTypes.oneOf(['center', 'left', 'right']),
};

export default Button;
